import { Badge } from '@radix-ui/themes';
import { numberToImperial } from 'lib_ts/classes/math.utilities';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const HitterHeightBadge = (props: { heightFt: number }) => {
  const impCoords = numberToImperial(props.heightFt);

  return <Badge color={RADIX.COLOR.NEUTRAL}>{impCoords.display}</Badge>;
};
